import ReactDOM from "react-dom/client";
import App from "./App";
import { msalInstance } from "./msalInstance";
import "./theme/theme.css";
import { initDemoView } from "./theme/demoView";

initDemoView();

;(window as any).__msal = msalInstance.getConfiguration();
console.log("MSAL auth config:", msalInstance.getConfiguration().auth);

const root = ReactDOM.createRoot(document.getElementById("root")!);

async function bootstrap() {
  try {
    // MSAL v5: initialize() must finish before any other MSAL API call.
    await msalInstance.initialize();

    // Process a pending login redirect BEFORE first render so the app boots
    // with the account already cached (avoids the blank/login-loop after sign-in).
    const response = await msalInstance.handleRedirectPromise();
    const account =
      response?.account ??
      msalInstance.getActiveAccount() ??
      msalInstance.getAllAccounts()[0];
    if (account) {
      msalInstance.setActiveAccount(account);
    }
  } catch (e) {
    console.error("MSAL bootstrap error:", e);
  } finally {
    root.render(<App />);
  }
}

bootstrap();
